<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="innerVisible"
    width="920px"
    custom-class="voip-auth-dialog"
    append-to-body
    :close-on-click-modal="false"
    @open="onOpen"
  >
    <div class="voip-auth-body">
      <div class="toolbar-filter-bar toolbar-filter-bar--embed">
        <el-form :inline="true" class="toolbar-filter-form" @submit.native.prevent="search">
          <div class="toolbar-filter-fields">
            <el-form-item>
              <el-input
                v-model="keyword"
                clearable
                placeholder="监护人 / 学生 / 手机号 / OpenId"
                class="toolbar-field-w-xl"
                @keyup.enter.native="search"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" icon="el-icon-search" @click="search">查询</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <el-table :data="list" v-loading="loading" border size="small" max-height="380" empty-text="暂无订阅家长">
        <el-table-column prop="ParentName" label="监护人" min-width="110" show-overflow-tooltip>
          <template slot-scope="scope">{{ pick(scope.row, 'ParentName', 'parentName') || '-' }}</template>
        </el-table-column>
        <el-table-column label="称谓" width="88" show-overflow-tooltip>
          <template slot-scope="scope">{{ pick(scope.row, 'ParentRelationDesc', 'parentRelationDesc') || '-' }}</template>
        </el-table-column>
        <el-table-column label="学生" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">{{ pick(scope.row, 'StudentName', 'studentName') || '-' }}</template>
        </el-table-column>
        <el-table-column label="手机号" width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ pick(scope.row, 'ParentMsisdn', 'parentMsisdn') || '-' }}</template>
        </el-table-column>
        <el-table-column label="订阅 OpenId" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">{{ pick(scope.row, 'OpenId', 'openId') || '-' }}</template>
        </el-table-column>
        <el-table-column label="最后订阅时间" width="170">
          <template slot-scope="scope">{{ formatTime(pick(scope.row, 'LastSubscribeTime', 'lastSubscribeTime', 'ModifyTime', 'modifyTime', 'CreateTime', 'createTime')) }}</template>
        </el-table-column>
      </el-table>
      <div class="voip-auth-pager">
        <el-pagination
          layout="total, prev, pager, next"
          :page-size="pageSize"
          :total="total"
          :current-page.sync="page"
          @current-change="loadList"
        />
      </div>
    </div>
    <div slot="footer">
      <el-button @click="innerVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getCommVoipParentAuthList } from '../../../api/modules/misc'

export default {
  name: 'VoipGroupAuthDialog',
  props: {
    visible: { type: Boolean, default: false },
    voipGroupId: { type: [Number, String], default: 0 },
    groupName: { type: String, default: '' }
  },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,
      keyword: ''
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    dialogTitle() {
      return this.groupName ? `订阅家长 - ${this.groupName}` : '订阅家长'
    }
  },
  watch: {
    voipGroupId() {
      if (this.visible) {
        this.page = 1
        this.keyword = ''
        this.loadList()
      }
    }
  },
  methods: {
    pick(row, ...keys) {
      if (!row) return ''
      for (let i = 0; i < keys.length; i++) {
        const v = row[keys[i]]
        if (v != null && v !== '') return v
      }
      return ''
    },
    formatTime(val) {
      if (!val) return '-'
      const s = String(val).replace('T', ' ')
      return s.length >= 19 ? s.slice(0, 19) : s
    },
    onOpen() {
      this.page = 1
      this.keyword = ''
      this.loadList()
    },
    search() {
      this.page = 1
      this.loadList()
    },
    async loadList() {
      const gid = Number(this.voipGroupId || 0)
      if (!gid) {
        this.list = []
        this.total = 0
        return
      }
      this.loading = true
      try {
        const res = await getCommVoipParentAuthList({
          voipGroupId: gid,
          keyword: (this.keyword || '').trim() || undefined,
          page: this.page,
          pageSize: this.pageSize
        })
        if (res.data.success) {
          const page = res.data.response || {}
          this.list = page.data || []
          this.total = page.dataCount || 0
        } else {
          this.$message.error(res.data.msg || '加载订阅名单失败')
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.voip-auth-pager {
  display: flex;
  justify-content: flex-end;
}
</style>
<style>
.voip-auth-dialog .el-dialog__body {
  padding: 20px 20px 24px;
}
.voip-auth-dialog .voip-auth-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.voip-auth-dialog .el-table {
  width: 100%;
}
.voip-auth-dialog .el-table__empty-block {
  min-height: 320px;
}
</style>
